import { render } from "./ObjetivoSku.vue?vue&type=template&id=712164bf"
import script from "./ObjetivoSku.vue?vue&type=script&lang=js"
export * from "./ObjetivoSku.vue?vue&type=script&lang=js"

import "./ObjetivoSku.vue?vue&type=style&index=0&id=712164bf&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__